module.exports = " <div class=vimeo _v-4431125b=\"\"> <div :id=elementId v-el:wrapper=\"\" _v-4431125b=\"\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-4431125b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vimeo.vue
// module id = 757
// module chunks = 2